import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file is automatically generated by running yarn icons:generate.
 */

import * as React from 'react';

function IconFolder16(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.694 3.333c-.736 0-1.332.597-1.333 1.332v.002l-.028 6.664v.002c0 .758.647 1.334 1.361 1.334h8.612c.715 0 1.36-.576 1.36-1.334V6c0-.757-.645-1.333-1.36-1.333H8.039l-1.218-.99c-.315-.262-.692-.344-1.029-.344H3.694zm-.333 1.334c0-.185.15-.334.333-.334h2.098c.183 0 .308.044.392.114l.004.004 1.358 1.104.138.112h4.622c.205 0 .36.17.36.333v.667H3.354l.008-1.998v-.002zm-.012 3l-.016 3.666v.001c0 .163.156.333.361.333h8.612c.205 0 .36-.17.36-.334V7.667H3.35z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(IconFolder16);
var MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;